import { connect } from 'react-redux'
import { doFetchTopLabels, doSearchLabels } from 'actions/labels'
import {
  selectTicketSearchSuggestions,
  selectIsTicketSearchSuggestions,
} from 'selectors/search_suggestions'
import { selectCurrentCommittedTicketSearchQueryFinalPart } from 'selectors/search/base'
import SearchSuggestions from './view'

export default connect(
  state => ({
    finalPart: selectCurrentCommittedTicketSearchQueryFinalPart(state),
    suggestions: selectTicketSearchSuggestions(state),
    isSuggestions: selectIsTicketSearchSuggestions(state),
  }),
  { doFetchTopLabels, doSearchLabels }
)(SearchSuggestions)
